/**
 * Pure field config for GlobalFilter on work items lists (no React).
 */

export function buildWorkItemsGlobalFilterFields({
  projectSlug,
  clientFilterOptions,
  projectFilterOptions,
  typeFilterOptions,
  statusOptionsForFilter,
  priorityFilterOptions,
  assigneeOptionsWithAvatar,
  /** All users — multiselect Reporter filter (same options shape as assignee). */
  reporterOptionsWithAvatar = [],
  teamOptions,
  /** My work items: list is already scoped to the current user — hide assignee/team filters. */
  showAssigneeAndTeam = true,
}) {
  return [
    {
      type: "input",
      name: "search",
      label: "Search",
      inputType: "text",
      placeholder: "Search by title, key, description…",
    },
    {
      type: "dropdown",
      name: "client",
      label: "Client",
      options: clientFilterOptions,
      placeholder: "Select Client",
      multiselect: true,
      searchable: true,
      visible: !projectSlug,
    },
    {
      type: "dropdown",
      name: "project",
      label: "Project",
      options: projectFilterOptions,
      placeholder: "Select Project",
      multiselect: true,
      searchable: true,
      visible: !projectSlug,
    },
    {
      type: "dropdown",
      name: "type",
      label: "Type",
      options: typeFilterOptions,
      placeholder: "Select Type",
      multiselect: true,
      searchable: true,
    },
    {
      type: "dropdown",
      name: "status",
      label: "Status",
      options: statusOptionsForFilter,
      placeholder: "Select Status",
      multiselect: true,
      searchable: true,
      preserveOptionOrder: true,
    },
    {
      type: "dropdown",
      name: "priority",
      label: "Priority",
      options: priorityFilterOptions,
      placeholder: "Select Priority",
      multiselect: true,
      searchable: true,
    },
    {
      type: "dropdown",
      name: "assignee",
      label: "Assignee",
      options: assigneeOptionsWithAvatar,
      placeholder: "Select Assignee",
      multiselect: true,
      searchable: true,
      visible: showAssigneeAndTeam,
    },
    {
      type: "dropdown",
      name: "reporter",
      label: "Reporter",
      options: reporterOptionsWithAvatar,
      placeholder: "Select Reporter",
      multiselect: true,
      searchable: true,
    },
    {
      type: "dropdown",
      name: "team",
      label: "Team",
      options: teamOptions,
      placeholder: "Select Team",
      multiselect: true,
      searchable: true,
      visible: showAssigneeAndTeam,
    },
    {
      type: "input",
      name: "dueAfter",
      label: "Due After",
      inputType: "date",
      placeholder: "Select Due After",
      visible: false,
    },
    {
      type: "input",
      name: "dueBefore",
      label: "Due Before",
      inputType: "date",
      placeholder: "Select Due Before",
      visible: false,
    },
  ];
}
